<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Cronograma Desembolso SEBRAE
        </b-button>
        <cronograma-desembolso-sebrae-form
            operacaoProp="I"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></cronograma-desembolso-sebrae-form>
    </div>
</template>

<script>
import CronogramaDesembolsoSebraeForm from './CronogramaDesembolsoSebraeForm'

export default {
    components: {
        CronogramaDesembolsoSebraeForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(cronograma){
            
            this.$store.dispatch('addRequest')
            let cronogramaDto = {
                pleitoId : cronograma.pleitoId,
                parcela: cronograma.parcela,
                mes: cronograma.mes,
                valor: cronograma.valor,
                descritivo:cronograma.descritivo
            }
            this.dataServicos.inserirCronogramaDesembolsoSebrae(cronogramaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Cronograma inserido com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
